"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 19",
    width: "24",
    height: "19"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M5,19c-1.4,0-2.5-1.1-2.5-2.5S3.6,14,5,14s2.5,1.1,2.5,2.5S6.4,19,5,19z M5,15c-0.8,0-1.5,0.7-1.5,1.5 S4.2,18,5,18s1.5-0.7,1.5-1.5S5.8,15,5,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M19,19c-1.4,0-2.5-1.1-2.5-2.5S17.6,14,19,14s2.5,1.1,2.5,2.5S20.4,19,19,19z M19,15 c-0.8,0-1.5,0.7-1.5,1.5S18.2,18,19,18s1.5-0.7,1.5-1.5S19.8,15,19,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M23.5,17H21c-0.3,0-0.5-0.2-0.5-0.5S20.7,16,21,16h2V1H10v3.5C10,4.8,9.8,5,9.5,5H5.3L2.9,9.2 c0,0-0.1,0.1-0.1,0.1L1,11.2V16h2c0.3,0,0.5,0.2,0.5,0.5S3.3,17,3,17H0.5C0.2,17,0,16.8,0,16.5V11c0-0.1,0.1-0.3,0.1-0.4l2-2 l2.5-4.4C4.7,4.1,4.8,4,5,4h4V0.5C9,0.2,9.2,0,9.5,0h14C23.8,0,24,0.2,24,0.5v16C24,16.8,23.8,17,23.5,17z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M17,17H7c-0.3,0-0.5-0.2-0.5-0.5S6.7,16,7,16h10c0.3,0,0.5,0.2,0.5,0.5S17.3,17,17,17z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M4.5,10c-0.1,0-0.2,0-0.2-0.1C4,9.8,3.9,9.5,4.1,9.3l1.5-3C5.6,6.1,5.8,6,6,6h1.5C7.8,6,8,6.2,8,6.5 S7.8,7,7.5,7H6.3L4.9,9.7C4.9,9.9,4.7,10,4.5,10z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M9.5,15C9.2,15,9,14.8,9,14.5v-10C9,4.2,9.2,4,9.5,4S10,4.2,10,4.5v10C10,14.8,9.8,15,9.5,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M23.5,15h-23C0.2,15,0,14.8,0,14.5S0.2,14,0.5,14h23c0.3,0,0.5,0.2,0.5,0.5S23.8,15,23.5,15z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "17.1",
    cy: "7.3",
    r: "4.3"
  }));
};

exports["default"] = _default;